import { gql } from '@apollo/client'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import React from 'react'

import { analyticsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useRankingState = () => React.useContext(Context)
export const useRanking = () => useRankingState()?.ranking

const QUERY = gql`
  query Rakning($perspective: String, $filter: RankingFilter) {
    ranking(perspective: $perspective, filter: $filter) {
      id
      recordId
      name
      openCount
      pendingCount
      completedCount
      averageTime
    }
  }
`

const RankingLoader = ({ widget, children }) => {
  const filter = useCleanFilterForRequest() || {}

  const { data, ...state } = useQuery(QUERY, {
    variables: { perspective: widget.data?.perspective || 'user', filter: filter },
    client: analyticsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default RankingLoader
